export const listMaterialCategories = /* GraphQL */ `
  query ListMaterialCategories($filter: ModelMaterialCategoryFilterInput, $limit: Int, $nextToken: String) {
    listMaterialCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        _deleted
        deleted
      }
      nextToken
    }
  }
`;

export const listMaterialCategoriesFullData = /* GraphQL */ `
  query ListMaterialCategories($filter: ModelMaterialCategoryFilterInput, $limit: Int, $nextToken: String) {
    listMaterialCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        abbreviation
        description
        createdAt
        updatedAt
        _version
        _deleted
        deleted
      }
      nextToken
    }
  }
`;
